import { useQuery } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import { ReceiptLineItem } from 'src/services/useReceiptLineItemsApi';
import axiosInstance from 'src/utils/axios';

export interface ReceiptLineItemsResponse {
  items: ReceiptLineItem[];
  totalRecords: number;
}

async function fetchReceiptLineItems(receiptId: number): Promise<ReceiptLineItem[]> {
  const response = await axiosInstance.get<ReceiptLineItem[]>(api.getReceiptLineItems(receiptId));
  return response.data;
}

export interface UseReceiptLineItemsQueryOptions {
  receiptId: number;
  enabled?: boolean;
}

export function useReceiptLineItemsQuery({
  receiptId,
  enabled = true,
}: UseReceiptLineItemsQueryOptions) {
  return useQuery<ReceiptLineItem[]>({
    queryKey: queryKeys.receipt.lineItems(receiptId),
    queryFn: () => fetchReceiptLineItems(receiptId),
    enabled: Boolean(receiptId) && enabled,
  });
}
